<script>
export default {
  props: {
    types: {
      type: Array,
      default: null,
    },
  },
};
</script>

<template>
  <div>
    <h5 class="mb-4 text-center">Selecione o tipo de atendimento</h5>

    <div v-if="!types" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="types.length == 0" class="text-center text-muted">
      Nenhum tipo de atendimento encontrado.
    </div>

    <div v-else>
      <div v-for="(type, index) in types" :key="index">
        <h5 style="text-transform: capitalize;">{{ type.name }}</h5>
        <div v-html="type.description"></div>
        <button class="btn btn-default btn-block btn-lg" @click="$emit('select-type', type.id)">Avançar</button>
      </div>
    </div>
  </div>
</template>
